import { render, staticRenderFns } from "./ContentCardBox.vue?vue&type=template&id=fe376890&"
import script from "./ContentCardBox.vue?vue&type=script&lang=js&"
export * from "./ContentCardBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports